import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { LocalStorage } from 'ngx-store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SessionService } from '../../service/session.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';


@Component({
    selector: 'app-logOn',
    templateUrl: './logOn.component.html',
    styleUrls: ['./logOn.component.css']
})
export class LogOnComponent implements OnInit {
    public logonForm: FormGroup;
    loading: boolean;
    admin: string;

    notifiedUsers=[];

    @LocalStorage('loggedUser') loggedUser: any;
    @LocalStorage('userData') userData: any;
    @LocalStorage('isAlsoAdmin') isAlsoAdmin: boolean;

    //translation for error snackbars
    err1: string
    err2: string
    err3: string
    err4: string
    err5: string
    err6: string
    err7: string

    constructor(
        private router: Router,
        private authService: AuthService,
        private device: DeviceDetectorService,
        private route: ActivatedRoute,
        private builder: FormBuilder,
        private snackBar: MatSnackBar,
        private sessionService: SessionService,
        public translate: TranslateService,
        private userService: UserService,
) {
        this.getTranslatedStrings()
    }

    getTranslatedStrings() {
        this.translate.get(['LOG_ON_ERR1', 'LOG_ON_ERR2', 'LOG_ON_ERR3', 'LOG_ON_ERR4', 'LOG_ON_ERR5', 'LOG_ON_ERR6','LOG_ON_ERR7'])
            .subscribe(translations => {
                this.err1 = translations['LOG_ON_ERR1']
                this.err2 = translations['LOG_ON_ERR2']
                this.err3 = translations['LOG_ON_ERR3']
                this.err4 = translations['LOG_ON_ERR4']
                this.err5 = translations['LOG_ON_ERR5']
                this.err6 = translations['LOG_ON_ERR6']
                this.err7 = translations['LOG_ON_ERR7']
            })
    }

    ngOnInit() {
        // Limpiar los datos del usuario al entrar a la página de Login. Por el
        // momento se hace acá, pero después debiese pasar en los guards o en algún
        // otro lado

        this.route.params.subscribe(paramsId => {
            if (paramsId.admin === 'admin') {
                this.admin = 'Roles';
            } else {
                this.admin = '';
            }
        });
        let lan = localStorage.getItem('lan')
        localStorage.clear();
        localStorage.setItem('lan', lan)
        this.logonForm = new FormGroup({
            email: new FormControl(null, [
                Validators.required,
                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
            password: new FormControl('', [
                Validators.required])
        });
    }

    async confirm() {
        const data = {
            email: this.logonForm.controls.email.value,
            password: this.logonForm.controls.password.value,
            admin: this.admin
        };

        if (this.logonForm.controls.email.status === "INVALID") {
            this.snackBar.open(this.err1, '', {
                duration: 5000,
            });
            return
        }
        if (this.logonForm.controls.password.value === '') {
            this.snackBar.open(this.err2, '', {
                duration: 5000,
            });
            return
        }
        this.userService.get_notified_users().then((data: any) => {
            this.notifiedUsers= data.body;})
        this.loading = true;
        const delay = ms => new Promise(res => setTimeout(res, ms));
        await delay(2000);
        this.authService.login(data)
            .then(resp => {
                this.loading = false;
                if (resp.status === 200) {
                    const body = resp.body;
                    const helper = new JwtHelperService();
                    const logge = body.token;
                    const user = helper.decodeToken(logge.access_token);
                    this.loggedUser = body.token;
                    this.userData = { session_id: body.session_id, email: body.email, role: body.role };

                    if (this.userData.role != 'admin') {
                        var dpi_x = document.getElementById('dpi').offsetWidth;
                        var dpi_y = document.getElementById('dpi').offsetHeight;
                        const data = {
                            browser: this.device.browser,
                            version: this.device.browser_version,
                            op_system: this.device.os,
                            op_system_version: this.device.os_version,
                            screen_resolution: screen.width + 'x' + screen.height,
                            pixel_density_h: dpi_y,
                            pixel_density_w: dpi_x,
                            user_agent: this.device.userAgent
                        };
                        this.sessionService.addSession(data).then(resp => {
                            if (resp.status === 200) {
                                this.router.navigate(['/'])
                            }
                        }).catch(e => {
                            console.log(e);
                            if (e.status === 401) {
                                console.log('Invalid Password');
                            }
                        });
                    }
                    else {
                        this.router.navigate(['/uni/data'])
                    }
                }
            }).then(() =>{
                // check if the logged user is also an admin
                this.userService.check_admin().then(data =>{
                    this.isAlsoAdmin = data.body.isAdmin;
                })
               
            })
            .catch(e => {
                this.loading = false;
                console.log(e);

                let contr=0;
                for (const user of this.notifiedUsers){
                    if(user.email===data.email && user.n_email_sended===2){
                        contr=1;
                    }
                }

                if (e.status === 401) {
                    
                    this.snackBar.open(this.err3, '', {
                        duration: 5000,
                    });
                } else if (e.status === 403) {
                    
                    this.snackBar.open(this.err4, '', {
                        duration: 5000,
                    });
                } else if (e.status === 404 || e.status === 0) {
                    
                    this.snackBar.open(this.err5, '', {
                        duration: 5000,
                    });
                } else if(e.status === 405 && contr===1){
                    this.snackBar.open(this.err7, 'OK');
                } else if(e.status === 405){
                    this.snackBar.open(this.err6, '', {
                        duration: 5000,
                    });
                }
            });
    }

    forgotPassword() {
        this.router.navigate(['/password-reset']);
    }

    emailNotConfirmed() {
        this.router.navigate(['/resend-link']);
    }
}
